import "@fontsource/noto-sans-tc/400.css";
import "@fontsource/noto-sans-tc/500.css";
import "@fontsource/noto-sans-tc/600.css";
import "@fontsource/noto-sans-tc/700.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/400.css";

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import './js/template-demo.js';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// templates
import './js/templates/home.js';
import './js/templates/faq.js';
import './js/templates/milestone.js';
import './js/templates/products.js';


// JavaScript
$(document).ready( function () {
  //scroll top
  // $('.back-to-top').click(function(event){
  //   $("html,body").animate({scrollTop: 0}, 1000);
  // });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').click(function (e) {
    if ($(window).width() <= 640) {
      if ($(this).siblings('.menu-dropdown-toggle').length > 0) {
        return true;
      }
    }
    $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  $('.menu-dropdown-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $parent = $(this).closest('.header-menu-link, .dropdown-link');
    $parent.toggleClass('active').siblings().removeClass('active');
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  $('#js-pagetop').on('click', function() {
    $('html, body').animate({
        scrollTop: 0
    }, 1000);
    return false;
  });

  const windowWidth = $(window).width();
  if ( windowWidth > 800 ) {
    let $navItems = $('.header-menu-link');
    $navItems.each(function() {
      let itemWidth = $(this).outerWidth();
      let itemLeftOffset = $(this).offset().left;
      let itemRightOffset = windowWidth - (itemLeftOffset + itemWidth);
      // 若右側空間不足, 子選單改成由左開啟 (子選單寬度230px)
      if ( itemRightOffset < 460 ) {
        $(this).addClass('open-to-left');
      }
    });
  }

});

